// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"MultiSelect_textContainer__cCngl","iconContainer":"MultiSelect_iconContainer__3KKbb","error":"MultiSelect_error__3z4k6","label":"MultiSelect_label__2EnYv"};